import React, { useState, useEffect } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import { useDispatch, useSelector } from "react-redux";
import ChangeShishePriceGroup from "./components/ChangeShishePriceGroup/ChangeShishePriceGroup";
import SpacerManage from "./components/SpacerManage/SpacerManage";
import ShisheManage from "./components/ShisheManage/ShisheManage";
import ShisheGroupManage from "./components/ShisheGroupManage/ShisheGroupManage";
import InsertMahsooleShishe from "./components/InsertMahsooleShishe/InsertMahsooleShishe";
import { GetAllMahsooleShishe } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import TblMahsooleshishe from "./components/TblMahsooleshishe/TblMahsooleshishe";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Translator from "Languages/Utility/Translator";

function Shishe() {
  const { mahsooleShishePagination, mahsooleShishe } = useSelector((state) => ({
    mahsooleShishePagination: state.shishe.mahsooleShishePagination,
    mahsooleShishe: state.shishe.mahsooleShishe,
  }));
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: mahsooleShishePagination.Limit,
          Page: mahsooleShishePagination.Page,
          Name: "",
        };
        await dispatch(GetAllMahsooleShishe(params));
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);

  const isAllAdmin = mahsooleShishe.some((item) => !item.IsG);

  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button side-button my-2">
        <PageTitle title={<Translator id={"Glass"}/>} />
        <div className="top-buttons justify-content-end">
          <div>
            {((read("mahsoleShisheRules").accessPrice2) || (isAllAdmin && read("mahsoleShisheRules").accessUpdate)) &&  <ChangeShishePriceGroup />}
            {(read("mahsoleShisheRules")?.accessRegister !== false) && <InsertMahsooleShishe />}
            {(read("SpacerRules") !== null && read("SpacerRules")?.accessShow !== false)  && <SpacerManage />}
            {(read("ShisheRules") !== null && read("ShisheRules")?.accessShow !== false) && <ShisheManage />}
            {(read("mahsoleShisheGroupRules") !== null && read("mahsoleShisheGroupRules")?.accessShow !== false) && <ShisheGroupManage />}
          </div>
        </div>
      </div>
      <MuiPaper className="mb-5">
        <TblMahsooleshishe />
      </MuiPaper>
    </>
  );
}

export default Shishe;
